import { render, staticRenderFns } from "./create-bi-store-gift.vue?vue&type=template&id=4c1790f9&scoped=true"
import script from "./create-bi-store-gift.vue?vue&type=script&lang=js"
export * from "./create-bi-store-gift.vue?vue&type=script&lang=js"
import style0 from "./create-bi-store-gift.vue?vue&type=style&index=0&id=4c1790f9&prod&lang=scss&scoped=true"
import style1 from "./create-bi-store-gift.vue?vue&type=style&index=1&id=4c1790f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1790f9",
  null
  
)

export default component.exports